import React from 'react';
import { Shield } from 'lucide-react';
import Tooltip from '../ui/Tooltip';
import { cn } from '../../utils/cn';

interface SLPendingPillProps {
  count: number;
  className?: string;
}

const SLPendingPill: React.FC<SLPendingPillProps> = ({ count, className }) => {
  if (count <= 0) return null;
  return (
    <Tooltip text="Morning re-placement expected shortly" position="top" className={className}>
      <span
        className={cn(
          'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium',
          'bg-yellow-50 dark:bg-yellow-900/20 text-yellow-700 dark:text-yellow-300',
          'border border-yellow-200 dark:border-yellow-900/40 tabular-nums',
        )}
      >
        <Shield className="w-3.5 h-3.5" />
        {count} SL PENDING
      </span>
    </Tooltip>
  );
};

export default SLPendingPill;
